import httpClient from '@/http-client'

export const employees = data =>
    httpClient
        .get('/api/reports/cash-request-reports/employees', data)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))

export const banks = data =>
    httpClient
        .get('/api/reports/cash-request-reports/banks', data)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))

export const currencies = data =>
    httpClient
        .get('/api/reports/cash-request-reports/currencies', data)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))

export const index = data =>
    httpClient
        .get('/api/reports/cash-request-reports', data)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))

export const pdf = data =>
    httpClient
        .get('/api/reports/cash-request-reports/pdf', data)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))

export const exportExcel = data =>
    httpClient
        .post('/api/reports/cash-request-reports/excel', data, {
            responseType: 'arraybuffer'
        })
        .then(response => Promise.resolve(response))
        .catch(error => Promise.reject(error.response.data))

export default { employees, banks, currencies, index, pdf, exportExcel }
